import { CSSProperties } from 'react';

type Style = {
    app: CSSProperties;
};

const style: Style = {
    app: {
        position: 'relative',
        justifyContent: 'center',
        display: 'flex',
        margin: 'auto',
        // marginTop: "240px",
        padding: '24px',
    },
};
export default style;
